import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="mx-auto mt-20 max-w-md text-center" data-testid="not-found-view">
      <p className="font-display text-6xl font-extrabold text-slate-200">404</p>
      <h1 className="mt-2 font-display text-2xl font-bold text-slate-900">Pagina non trovata</h1>
      <p className="mt-2 text-sm text-slate-500">La pagina richiesta non esiste o è stata spostata.</p>
      <Button asChild variant="outline" className="mt-6" data-testid="not-found-back-button"><Link to="/dashboard">Torna alla Dashboard</Link></Button>
    </div>
  );
}
